"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveBrandBodyFont = exports.FONT_FAMILY = void 0;
var types_1 = require("../types");
exports.FONT_FAMILY = ['"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(',');
function resolveBrandBodyFont(brand) {
    var fontFamilies = ['Roboto', "'Segoe UI'", "'Helvetica Neue'", 'Arial', 'sans-serif'];
    switch (brand) {
        case types_1.TAGBrand.AspenDental:
        case types_1.TAGBrand.Enterprise:
            fontFamilies.unshift("'Messina Sans'");
            break;
        case types_1.TAGBrand.Chapter:
            fontFamilies.unshift("'Helvetica Neue LT Pro'");
            break;
        case types_1.TAGBrand.ClearChoice:
            fontFamilies.unshift("'Beausite Classic'");
            fontFamilies.unshift("'Burgess Pro'");
            break;
        case types_1.TAGBrand.AZPetVet:
            fontFamilies.unshift("'Lato'");
            break;
        case types_1.TAGBrand.Lovet:
            fontFamilies.unshift('Lato');
            break;
        case types_1.TAGBrand.Motto:
            fontFamilies.unshift("'EB Garamond'");
            fontFamilies.unshift("'Qanelas Soft'");
            break;
        case types_1.TAGBrand.WellNow:
            fontFamilies.unshift('Avenir');
            break;
        case types_1.TAGBrand.LivWellNow:
            fontFamilies.unshift('Avenir');
            fontFamilies.unshift('Montserrat');
            break;
        case types_1.TAGBrand.TeamTAG:
            fontFamilies.unshift("'Messina Modern'");
            break;
        default:
            fontFamilies.unshift("'Messina Sans'");
    }
    return fontFamilies.join(',');
}
exports.resolveBrandBodyFont = resolveBrandBodyFont;
